export class PriceHelper {
  priceToCents(price: number): number {
    return price * 100;
  }

  centsToPrice(price: number): number {
    return price / 100;
  }
}
